import React from 'react'
import { motion } from "framer-motion"
import { useEase } from "../motion"

export const TitleHome = (props) => {

  const parentControl = {
		closed: {
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1,
			},
		},
		open: {
			opacity: 1,
			transition: {
				ease: useEase("easeOutExpo"),
				duration: 1.5,
				delayChildren: 1.35,
        staggerChildren: 0.1,
        staggerDirection: -1,
				when: "afterChildren",
			},
		},
	}

	const letterVar = {
		closed: {
			x: -400,
			y: -9.91,
			opacity: 0,
		},
		open: {
			x: -18.43,
			y: -9.91,
			opacity: 1,
			transition: {
				ease: useEase("easeInExpo"),
				duration: 0.5,
			},
    },
  }

   return (
		<div className="chapter-title">
			<motion.svg
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				viewBox="0 0 820.77 52.27"
				variants={parentControl}
				initial="closed"
				animate={props.coverLoaded ? "open" : "closed"}
				exit="closed"
			>
				<defs>
					<clipPath id="clipPath" transform="translate(-18.43 -9.91)">
						<rect
							id="group_mask"
							width="847"
							height="68"
							fill="none"
						/>
					</clipPath>
				</defs>
				<g id="home" className="isolation">
					<g clipPath="url(#clipPath)">
						<motion.g variants={letterVar} id="a">
							<path
								d="M39.82,61.59,42.67,50.2H33.25L26.82,61.59H18.43l30.26-51.1H59.35L48.21,61.59Zm4.54-18.4L50,20.49,37.2,43.19Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
						</motion.g>
						<motion.g variants={letterVar} id="race">
							<path
								d="M105.84,21.3l-3.71,9.12c-2,5-5.16,8.1-9.38,9.64L91.21,61.59h-8.4l1.86-20.37H80.14L71.86,61.59H63.4l20.77-51.1H97.38C104.39,10.49,109,13.56,105.84,21.3ZM94.06,17.94H89.61l-6.47,16h4.45c2.78,0,5.06-1,6.56-4.67l2.7-6.64C98.35,19,96.83,17.94,94.06,17.94Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M114.64,61.59l2.85-11.39h-9.42l-6.42,11.39h-8.4l30.27-51.1h10.65L123,61.59Zm4.54-18.4,5.68-22.7L112,43.19Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M156.57,51.37c-3.21,7.88-8.78,10.8-17.24,10.8h-.15c-7,0-11.75-2.84-8.46-10.8L143.2,20.71c3.07-7.59,8.78-10.8,17.24-10.8h.15c7,0,11.52,3.21,8.46,10.8l-3.84,9.35h-8.47l3.32-8c1.41-3.58.13-4.68-2.58-4.68s-4.92,1.1-6.33,4.68l-11.44,28c-1.48,3.57-.13,4.67,2.58,4.67s4.85-1.1,6.33-4.67l3.75-9.27h8.46Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M159.1,61.59l20.77-51.1h22.41l-3,7.45H185.31l-5.65,14h11.68l-3,7.45H176.63l-6,14.75h14.16l-3,7.44Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
						</motion.g>
						<motion.g variants={letterVar} id="to">
							<path
								d="M239.76,17.94h-8.54L213.48,61.59H205l17.75-43.65h-8.55l3-7.45H242.8Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M259.72,9.91h.59c7,0,11.55,3.06,8.45,10.8L256.28,51.37c-3.17,7.74-8.77,10.8-17.24,10.8h-.58c-7,0-11.63-3.06-8.46-10.8l12.48-30.66C245.67,12.9,251.25,9.91,259.72,9.91ZM241.78,54.73c2.78,0,5.06-1,6.56-4.67l11.43-28c1.43-3.65,0-4.68-2.79-4.68s-5.13,1-6.55,4.68L239,50.06C237.49,53.71,239,54.73,241.78,54.73Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
						</motion.g>
						<motion.g variants={letterVar} id="bring">
							<path
								d="M301.52,35c3.86.66,4.29,4.16,2.73,8.1l-3.47,8.4c-2.58,6.42-8.32,10.07-16.78,10.07H270.78l20.78-51.1h13.36c7,0,10.84,3.65,8.19,10.07L310.53,27C308.79,31.37,305.8,34.51,301.52,35Zm-7.94,3.72h-5l-6.29,15.55h5a5.68,5.68,0,0,0,5.51-3.94L296,42.68C297,40,296,38.74,293.58,38.74Zm-2.15-7.15h4.75a5.82,5.82,0,0,0,5.58-3.94l2.39-5.92c1.13-2.7.11-3.94-2.3-3.94H297.1Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M345.42,21.3l-3.71,9.12c-2,5-5.16,8.1-9.38,9.64l-1.54,21.53h-8.4l1.86-20.37h-4.53l-8.28,20.37H303l20.77-51.1H337C344,10.49,348.59,13.56,345.42,21.3Zm-11.78-3.36h-4.45l-6.47,16h4.46c2.77,0,5.05-1,6.55-4.67l2.7-6.64C337.93,19,336.41,17.94,333.64,17.94Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M336.19,61.59,357,10.49h8.46l-20.77,51.1Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M352.25,61.59,373,10.49h8.32l-2,31.61,12.85-31.61H400l-20.77,51.1H371.3l2.2-33.21L360,61.59Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M416.66,51.37c-3.21,7.88-8.77,10.8-17.24,10.8h-.58c-7,0-11.76-2.84-8.46-10.8l12.48-30.66c3.07-7.59,8.77-10.8,17.24-10.8h.58c7,0,11.53,3.21,8.46,10.8l-3,7.3h-8.47l2.48-6c1.43-3.65,0-4.68-2.79-4.68s-5.13,1-6.55,4.68l-11.44,28c-1.5,3.65,0,4.67,2.79,4.67s5-1,6.55-4.67l3.07-7.59h-5l2.89-7.16h13.43Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
						</motion.g>
						<motion.g variants={letterVar} id="students">
							<path
								d="M460.28,28.74l3-7.15c1.25-3.21-.09-4.38-2.57-4.38s-4.79,1.17-6.05,4.38l-1.46,3.5c-1.05,2.63-.87,4.09,1,5.48l4.62,3.35c3.87,2.85,5.85,5,3.7,10.22l-3,7.38c-3.21,7.88-8.45,10.65-16.92,10.65h-.14c-7,0-11.57-2.7-8.35-10.65l3.66-8.91h8.33l-3.18,7.74c-1.23,3.14,0,4.52,2.54,4.52a6.54,6.54,0,0,0,6.22-4.52l1.66-4c1.15-2.77.83-4.23-1.11-5.62l-4.55-3.36c-3.37-2.48-5.48-5.69-3.63-10.21l2.72-6.72c3.14-7.59,9.14-10.51,16.88-10.51h.14c6.28,0,11.37,2.92,8.23,10.51l-3.38,8.32Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M501.61,17.94h-8.54L475.33,61.59h-8.47L484.6,17.94h-8.54l3-7.45h25.55Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M518,51.37c-3.2,7.88-8.62,10.8-17.09,10.8h-.29c-7,0-11.61-2.84-8.31-10.8l16.59-40.88h8.47L501.28,50.06c-1.5,3.65-.28,4.67,2.5,4.67s4.76-1,6.26-4.67l16.07-39.57h8.46Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M563.25,21.3l-12,29.49c-3.17,7.73-8.77,10.8-17.24,10.8H521l20.78-51.1H554.8C561.8,10.49,566.42,13.56,563.25,21.3Zm-11.78-3.36h-4.31L532.45,54.15h4.31c2.77,0,5-1,6.55-4.68l11-26.86C555.76,19,554.24,17.94,551.47,17.94Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M553.87,61.59l20.78-51.1h22.41l-3,7.45H580.08l-5.64,14h11.68l-3,7.45H571.41l-6,14.75h14.16l-3,7.44Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M582.49,61.59l20.78-51.1h8.32l-2,31.61,12.84-31.61h7.74l-20.77,51.1h-7.89l2.2-33.21L590.23,61.59Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M657.1,17.94h-8.54L630.82,61.59h-8.47l17.74-43.65h-8.54l3-7.45h25.55Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M672.71,28.74l3-7.15c1.26-3.21-.08-4.38-2.56-4.38a6.19,6.19,0,0,0-6.05,4.38l-1.47,3.5c-1,2.63-.87,4.09,1,5.48l4.63,3.35c3.87,2.85,5.85,5,3.7,10.22l-3,7.38c-3.2,7.88-8.44,10.65-16.91,10.65h-.15c-7,0-11.56-2.7-8.34-10.65l3.66-8.91h8.32l-3.17,7.74c-1.23,3.14,0,4.52,2.53,4.52a6.55,6.55,0,0,0,6.23-4.52l1.66-4c1.15-2.77.83-4.23-1.11-5.62l-4.56-3.36c-3.37-2.48-5.47-5.69-3.62-10.21l2.71-6.72C662.29,12.83,668.3,9.91,676,9.91h.14c6.28,0,11.37,2.92,8.23,10.51L681,28.74Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
						</motion.g>
						<motion.g variants={letterVar} id="home-2">
							<path
								d="M714.88,10.49l-8.64,21.32H716l8.64-21.32h8.47l-20.78,51.1h-8.47l9.07-22.19h-9.71l-9.06,22.19h-8.47l20.77-51.1Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M753.19,9.91h.59c7,0,11.55,3.06,8.45,10.8L749.75,51.37c-3.17,7.74-8.77,10.8-17.24,10.8h-.58c-7,0-11.63-3.06-8.46-10.8L736,20.71C739.15,12.9,744.73,9.91,753.19,9.91ZM735.25,54.73c2.78,0,5.06-1,6.56-4.67l11.43-28c1.43-3.65,0-4.68-2.79-4.68s-5.12,1-6.55,4.68l-11.44,28C731,53.71,732.48,54.73,735.25,54.73Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M775.9,54.15h-4.74l2-23.8L760.46,61.59h-7.88l20.77-51.1h7.89L779.05,40.2l22-29.71h8.47l-20.78,51.1h-8.17l12.68-31.24Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
							<path
								d="M796,61.59l20.78-51.1H839.2l-3,7.45H822.22l-5.64,14h11.68l-3,7.45H813.55l-6,14.75h14.16l-3,7.44Z"
								// transform="translate(-18.43 -9.91)"
								fill="currentColor"
							/>
						</motion.g>
					</g>
				</g>
			</motion.svg>
		</div>
   )
}